import ReferralContextService from './ReferralContextService';

export default ReferralContextService;
